import React from 'react'

function SplitRow (props) {
  return (
    <div className='bg-white flex justify-between whitespace-no-wrap py-3 px-6 md:px-8'>
      {props.children}
    </div>
  )
}

export default SplitRow
